export const getSecureKey = (
  platform: 'mobile' | 'web',
  env: string,
  key: string
) => {
  const secureKey = `stablehouse-${platform}-${env}-${key}`;
  return secureKey;
};
